import React from 'react';
import GrtButton from '../Web/GrtButton'; // 导入GrtButton组件
import { Display } from '../Display/Display';
const ResearchPlanCard = ({
    skillStore,
    planData,
    isLatestPlan,
    onEditPlan,
    onStartResearch,
    disabled = false, // 添加disabled属性，默认为false
    sessionId // 🔥 新增：接收sessionId参数
}) => {
    const [localDisabled, setLocalDisabled] = React.useState(false); // 本地立即禁用，避免 setState 延迟导致的可点击问题
    const planId = `plan_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
    return (
        <div className="research-plan-container" data-plan-id={planId}>
            <div
                className="research-plan"
                style={{
                    padding: '24px',
                    backgroundColor: '#f9f9fb',
                    borderRadius: '8px',
                    marginBottom: '16px'
                }}
            >
                <h2
                    style={{
                        fontSize: '24px',
                        marginBottom: '16px',
                        fontWeight: 'bold'
                    }}
                >
                    {planData.title}
                </h2>
                <p
                    style={{
                        marginBottom: '20px',
                        fontSize: '15px',
                        lineHeight: '1.6'
                    }}
                >
                    {planData.thought || ''}
                </p>
                {planData.steps && planData.steps.length > 0 && (
                    <div className="steps">
                        <h3
                            style={{
                                fontSize: '18px',
                                marginBottom: '12px',
                                fontWeight: 'bold'
                            }}
                        >
                            步骤：
                        </h3>
                        <ol
                            style={{
                                paddingLeft: '20px',
                                marginBottom: '0'
                            }}
                        >
                            {planData.steps.map((step, index) => (
                                <li
                                    key={index}
                                    style={{
                                        marginBottom: '16px',
                                        fontSize: '15px'
                                    }}
                                >
                                    <h4
                                        style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            marginBottom: '6px'
                                        }}
                                    >
                                        {step.title}
                                    </h4>
                                    <p
                                        style={{
                                            fontSize: '14px',
                                            lineHeight: '1.5'
                                        }}
                                    >
                                        {step.description}
                                    </p>
                                </li>
                            ))}
                        </ol>
                    </div>
                )}
            </div>
            <Display show={skillStore?.skillAvailable}>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', backgroundColor: 'transparent' }}>
                    <GrtButton
                        onClick={(e) => {
                            if (disabled || localDisabled) return; // 如果禁用则不执行点击操作
                            e.preventDefault();
                            e.stopPropagation();
                            // 不在这里设置 setLocalDisabled，避免影响其它按钮的可用性
                            // 通过事件机制通知外层展示/聚焦到编辑输入框（由父组件或订阅者处理）
                            window.dispatchEvent(
                                new CustomEvent('research-plan-edit', {
                                    detail: {
                                        planId: planId,
                                        sessionId: sessionId,
                                        timestamp: Date.now(),
                                        interrupt_feedback: 'edit_plan'
                                    }
                                })
                            );
                            if (typeof onEditPlan === 'function') {
                                onEditPlan();
                            }
                        }}
                        disabled={!isLatestPlan || disabled}
                        style={{
                            minWidth: '104px',
                            boxShadow: 'none',
                            border: 'none',
                            backgroundColor: '#F7F9FB'
                        }}
                    >
                        修改方案
                    </GrtButton>
                    <GrtButton
                        onClick={(e) => {
                            if (disabled || localDisabled) return; // 如果禁用则不执行点击操作
                            e.preventDefault();
                            e.stopPropagation();
                            setLocalDisabled(true); // 立即本地禁用，防止短时间内重复点击
                            // 🔥 派发开始研究事件，通知WebSender显示暂停图标
                            window.dispatchEvent(
                                new CustomEvent('research-plan-started', {
                                    detail: {
                                        planId: planId,
                                        sessionId: sessionId, // 🔥 传递sessionId，让事件处理器知道要更新哪个会话
                                        timestamp: Date.now()
                                    }
                                })
                            );

                            if (typeof onStartResearch === 'function') {
                                onStartResearch();
                            }
                        }}
                        type="primary"
                        disabled={!isLatestPlan || disabled || localDisabled}
                        style={{
                            minWidth: '104px',
                            boxShadow: 'none',
                            border: 'none',
                            ...((!isLatestPlan || disabled) && {
                                backgroundColor: 'var(--bg-color-grt-primary-4)'
                            })
                        }}
                    >
                        开始研究
                    </GrtButton>
                </div>
            </Display>
        </div>
    );
};

export default ResearchPlanCard;
